import { useFormState } from 'informed';
import { useReduxState } from 'hooks';
import { localeNames } from 'shared-locales';
import {
  CertificatesPreview,
  CertificatesSelectTemplate
} from 'components/admin/settings/certificates';
import {
  Checkbox,
  Emails,
  FormGroup,
  FormSection,
  Select,
  TextArea
} from 'components/common/form';

interface CertificateFormValues {
  CertificateTemplateId?: number;
  certificateAllowDownloading?: boolean;
  certificateCustomContent?: string;
  certificateLanguage?: string;
  certificateSendToOtherEmails?: boolean;
  certificateSendToOtherEmailsList?: string[];
  certificateSendToUser?: boolean;
}

const CalendarEventCertificates = () => {
  const {
    messages,
    pageState: { calendarEvent },
    serverConfig
  } = useReduxState();

  const formState = useFormState<CertificateFormValues>();

  return (
    <FormSection title={messages.commonCertificate}>
      {serverConfig.certificatesEnableSelection && (
        <CertificatesSelectTemplate maxWidth={200} type="calendar-event" />
      )}

      <FormGroup>
        <CertificatesPreview
          certificateType="calendar-event"
          customContent={formState.values.certificateCustomContent || ''}
          templateId={
            (formState.values?.CertificateTemplateId as number) ||
            calendarEvent.CertificateTemplateId ||
            serverConfig.defaultCertificateTemplateId
          }
          title={calendarEvent.title}
        />
      </FormGroup>

      <FormGroup
        htmlFor="certificate-custom-content"
        label={messages.settingsCertificateCustomContent}
        {...(serverConfig.certificatesEnableSelection
          ? { style: { marginTop: 25 } }
          : {})}
      >
        <TextArea
          field="certificateCustomContent"
          id="certificate-custom-content"
          maxLength={180}
        />
      </FormGroup>

      <FormGroup>
        <Checkbox
          field="certificateAllowDownloading"
          id="certificateAllowDownloading"
          label={messages.settingsCertificateAllowDownloading}
          style={{ marginTop: 20 }}
        />

        <Checkbox
          field="certificateSendToUser"
          id="certificateSendToUser"
          label={messages.settingsCertificateSendToUser}
          style={{ marginTop: 10 }}
        />

        <Checkbox
          field="certificateSendToOtherEmails"
          id="certificateSendToOtherEmails"
          label={messages.settingsCertificateSendToEmails}
          style={{ marginTop: 10 }}
        />

        <Emails
          disabled={!formState.values.certificateSendToOtherEmails}
          field="certificateSendToOtherEmailsList"
          id="certificateSendToOtherEmailsList"
          style={{ marginLeft: 20, marginTop: 8 }}
        />
      </FormGroup>

      <FormGroup label={messages.settingsCertificateLanguage}>
        <Select
          field="certificateLanguage"
          id="certificateLanguage"
          options={Object.keys(localeNames).map((localeKey) => ({
            label: localeNames[localeKey],
            value: localeKey
          }))}
          style={{ maxWidth: 200 }}
        />
      </FormGroup>
    </FormSection>
  );
};

export default CalendarEventCertificates;
